module.exports = __webpack_public_path__ + "img/kid5.2da7a220.jpg";